import { Link, Outlet } from 'react-router-dom';
import Navbar from '../components/visitantes/Navbar';
import Footer from '../components/administracao/Footer';

export default function HomePage() {
    return (
        <>
            <div className="app d-flex m-0 p-0">
                <Navbar />
                <div id="content" className="content pr-0 m-0">
                    <div className="main col m-0">
                        <Outlet />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};